import React from "react";
import "../styles/home.css";
import PromoPopup from "./PromoPopup";

const promoText = `✨Weekday Wellness Special! ✨
Choose ANY 2 treatments for just $99 cash only 🌿 (Monday–Friday only)`

const services = ['👣 Relaxing Foot Reflexology', '💆 Stress-relieving Massage', '🌸 Refreshing Facial']
const Home: React.FC = () => (
    <>
        <PromoPopup message={promoText} services={services} />
        <div className="section home">
            <div className="home-overlay">
                <h1 className="spa-title">Cedarwood Wellness</h1>
                <p className="spa-subtitle">Where tranquility meets luxury</p>
                <p className="spa-text">
                    Discover peace and rejuvenation in the heart of nature. Our spa blends
                    ancient therapies with modern wellness to restore balance to your mind,
                    body, and soul.
                </p>
                {/* <button className="cta-btn">Book Now</button> */}
            </div>

        </div>
        <div className="promo-banner">
            <span>{promoText} <br />{services.map(s => s)}</span>
        </div></>
);

export default Home;
